import { StoreImage } from "./components/StoreImage";

export default StoreImage;
